import React from 'react';
import classNames from 'classnames';

import css from './IconMotorcycle.module.css';

/**
 * Motorcycle / bike icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @returns {JSX.Element} SVG icon
 */
const IconMotorcycle = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <circle cx="5" cy="16" r="3" />
      <circle cx="19" cy="16" r="3" />
      <path d="M12 16h-4l3-7 4 1 2 6" />
      <path d="M7 6h3l2 3" />
      <path d="M17 9l1-3h3" />
    </svg>
  );
};

export default IconMotorcycle;
